import { PrimitiveValueObjectDateTime } from '@/domain/primitiveValueObjectDateTime';

/**
 * 出席日時
 */
export class AttendDateTime extends PrimitiveValueObjectDateTime {
  /**
   * 作成
   * @param value 値
   * @returns 値
   */
  static create(value: Date): AttendDateTime {
    return new AttendDateTime(value);
  }

  /** キー */
  static get key(): string {
    return 'attendDateTime';
  }

  /** ラベル */
  static get label(): string {
    return '登園時刻';
  }

  /** labelDate */
  static get labelDate(): string {
    return '日付';
  }

  /** labelTime */
  static get labelTime(): string {
    return '時刻';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }
}
